import { mapToBreakpoints, spacing } from '@koaly/mixins';

const getColGutterStyle = (values) => {
    return mapToBreakpoints(values, (value) => {
        return `
      padding-left: calc(${spacing(value)} / 2);
      padding-right: calc(${spacing(value)} / 2);
    `;
    });
};
const getGridGutterStyle = (values) => {
    return mapToBreakpoints(values, (value) => {
        return `
      margin-left: calc((${spacing(value)} / 2) * -1);
      margin-right: calc((${spacing(value)} / 2) * -1);
    `;
    });
};
const getRowColGutterStyle = (values) => {
    return mapToBreakpoints(values, (value) => {
        return `
      padding-top: calc(${spacing(value)} / 2);
      padding-bottom: calc(${spacing(value)} / 2);
    `;
    });
};
const getRowGridGutterStyle = (values) => {
    return mapToBreakpoints(values, (value) => {
        return `
      margin-top: calc((${spacing(value)} / 2) * -1);
      margin-bottom: calc((${spacing(value)} / 2) * -1);
    `;
    });
};

export { getColGutterStyle, getGridGutterStyle, getRowColGutterStyle, getRowGridGutterStyle };
//# sourceMappingURL=getGutterStyle.js.map
